
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0a21"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0a21"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $27baee381e454eeb$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["2BF4I","index.4e60a1d5.js","1frx2","page_turner_logo.64063b1a.svg","aYOIr","page_turner_logo_orange.45cea763.svg","lxWGs","plot_twist.474b75bd.svg","iU7jw","plot_twist_orange.1b5dfb1e.svg","6GW9v","menu.f437d57e.svg","2rI4S","menuorange.37d2519b.svg","bLzma","shimmer_img.682f9d6f.gif","kbtDL","search.fb32cd06.svg","iurzx","highlights.ecdf08e5.svg","hPJ5P","genres.13344d4a.svg","cLQpS","quotes.faf956aa.svg","h1vJY","library.085e4b28.svg","foWyF","close.577e78eb.svg","5fnwz","closeorange.de3928aa.svg","ba0B3","1.0c733a62.svg","h0zNK","2.4ad594a1.svg","fj3ur","3.60ff3165.svg","h3ozj","4.562de07f.svg","8nLNP","5.8e4566b7.svg","1ydw4","6.30dba897.svg","fhmrB","7.d9818051.svg","eBxiQ","8.98f633aa.svg","1QtbZ","9.3e634a41.svg","aYTiQ","10.2e57fc6c.svg","3vqm8","11.cd55873c.svg","3gtt4","12.83c1d640.svg","8iflx","13.ac8847e1.svg","dn0hq","14.3f630d38.svg","5C4D6","15.a157d196.svg","bNk8z","16.c1949eab.svg","2Ikoy","17.c0784a94.svg","44sqJ","18.d74c5505.svg","pMV01","19.fbbcef20.svg","kmDYJ","20.94046c3f.svg","aWIsY","21.895e0b80.svg","ho59D","22.4b014aa7.svg","6jGzH","23.f906aa09.svg","6c5U5","24.092f32f6.svg","d9ULP","25.25c17c0a.svg","dTIHZ","26.84c68a48.svg","hKdLa","27.2a6365a3.svg","dfloY","28.981c263e.svg","3uuPy","29.93bd4df5.svg","4QFeZ","30.fadfbd12.svg","3ngMh","31.0c1cbd9f.svg","eQjZX","32.f8c0f9d7.svg","3wh6J","33.1d1f13d9.svg","CqOZ6","37.4a98f8f7.svg","6VfbL","35.b90d7b4f.svg","3NzfO","36.0680ef0b.svg","9WnKR","search-white.96126d3a.svg","j2UL4","search-orange.10418e04.svg","dNXp4","main_img.61c8c4e9.svg","lkSRu","square_img.9de9f5b7.svg","kJy26","screen_1.0acaf4a2.svg","zUZYM","screen_2.04467a59.svg","81YO7","screen_3.6e99b113.svg","c6Za1","size_img.ca8c5add.svg","lVEnJ","last_img.d5b8d0a5.svg","kaQuM","light.3f2364b9.svg","kQ3s1","dark.9af9b551.svg","aViER","orange.8248263c.svg","8koGT","index.c86bbe36.css"]'));


//# sourceMappingURL=index.runtime.9c2466a8.js.map
